import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchCustomer } from 'actions'
import { getCustomerDataByWorkspaceSlug, getCustomerRequestByWorkspaceSlug } from 'selectors'
import CustomersProfile from '../components/Customers/CustomersProfile'

class CustomersProfileApp extends Component {
  render () {
    return React.createElement(CustomersProfile, this.props)
  }

  componentDidMount () {
    this.props.onMount()
  }
}

function mapStateToProps (state, ownProps) {
  const { workspaceSlug } = ownProps.params
  const { path } = ownProps.routes[2]

  const customer = getCustomerDataByWorkspaceSlug(state, workspaceSlug)
  const { isRequesting, didRequestFail } = getCustomerRequestByWorkspaceSlug(state, workspaceSlug)

  return {
    isRequesting,
    didRequestFail,
    user: customer,
    workspaceSlug,
    path
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const { workspaceSlug, profileId } = ownProps.params

  return {
    onMount: () => {
      dispatch(fetchCustomer(workspaceSlug, profileId))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersProfileApp)



// WEBPACK FOOTER //
// ./containers/CustomersProfileApp.js